/**
 * @author Fernando Ruano
 * @file index.jsx
 * @description Profiles Creation View Page.
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import FormGenerator from '@nephro/components/FormGenerator';

// Helpers
import {
  bottomOptionsCreateEdit,
  formItemNameDesc
} from '@nephro/commons/helpers/utils';

// Styles
import styles from './styles.module.css';

const profileData = {};

/**
 * Profiles Creation View
 * @param { Object } profileActions - Profile Actions.
 * @param { Object } actions - App Actions.
 * @return { Node } React node.
 */
const ProfilesCreationView = ({ profileActions }) => {
  const history = useHistory();
  const { createProfile } = profileActions;
  const { t: translate } = useTranslation();

  const onGoBack = () => {
    history.goBack();
  };

  // Function to get on submit form values
  const onFinish = (values) => {
    createProfile(values, onGoBack);
  };

  return (
    <div className="flex flex-col h-full px-7 pt-5 pb-7 ">
      <FormGenerator
        initialValues={profileData}
        onFinish={onFinish}
        items={formItemNameDesc(translate)}
        bottomOptions={bottomOptionsCreateEdit(
          onGoBack,
          translate,
          'create',
          styles.actionButton
        )}
      />
    </div>
  );
};

/**
 * Component definition of proptypes.
 */
ProfilesCreationView.propTypes = {
  profileActions: PropTypes.shape({
    createProfile: PropTypes.func.isRequired
  }).isRequired
};

export default ProfilesCreationView;
